import { render, staticRenderFns } from "./ElderAbility.vue?vue&type=template&id=1c6f21f0&"
import script from "./ElderAbility.vue?vue&type=script&lang=js&"
export * from "./ElderAbility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports